import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-invoice-mark-as-paid-modal',
  components: {},
})
export default class InvoiceMarkAsPaidModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'invoice-mark-as-paid-modal' }) readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop(Object) entity;
  @Prop({ type: Boolean, default: false }) readonly isBulk: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedItemIds: number[];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly filterModel;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly searchAndOrder: SearchAndOrder;

  // DATA
  public requestSent: boolean = false;
  public isProcessing: boolean = false;
  public eventsSuccess = [];
  public eventsError = [];
  showModalIndex = null;
  readonly errorMessageText: string = 'global.generic.error_form_action';

  // COMPUTED
  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    this.showModalIndex = Date.now();
    this.initVars();
    if (this.showModal) {
      this.openModal();
    }
  }

  initVars() {
    this.requestSent = false;
    this.isProcessing = false;
    this.eventsSuccess = [];
    this.eventsError = [];
  }

  // METHODS
  closeModal() {
    this.showModalIndex = Date.now();
    this.$emit('close-modal');
    this.initVars();
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onConfirm(processAll: boolean = false) {
    // TODO: Extract function in a service and recieve it by props (perhaps the form component should be in charge of making the request)
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice');
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketMarkInvoicesAsPaidChannel(sessionCode);

    this.requestSent = true;
    this.isProcessing = true;

    const payload: AnyEntity = {
      ids: this.selectedItemIds,
      filters: this.filterModel,
      search_and_order: this.searchAndOrder,
      process_all: processAll,
      session_code: sessionCode,
    };

    this.$bpcApi.post(basePath + '/mark-as-paid', payload).subscribe(
      res => {
        this.requestSent = true;
      },
      error => {
        this.requestSent = false;
        this.isProcessing = false;
        this.$bpcMessage.showErrorMessage({ text: this.errorMessageText });
      },
    );
  }

  getSessionCode() {
    return `mark-invoice-as-paid-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  listenToWebsocketMarkInvoicesAsPaidChannel(sessionCode) {
    this.isProcessing = true;
    this.$bpcEcho
      .getMarkInvoicesAsPaidChannel(sessionCode)
      .listen('.BPC\\Accounting\\Events\\InvoicesMarkedAsPaid', data => {
        // If not are invoices marked as paid dont show succes alert.
        if (data.result.invoices_processed.length) {
          this.$bpcMessage.showInfoMessage({
            text: 'global.accounting.invoices.invoices_marked_as_paid',
          });
        }
        this.isProcessing = false;
        this.$emit('invoices-mark-as-paid-finished');
        this.$bpcEcho.leaveMarkInvoicesAsPaidChannel(sessionCode);
      })
      .listen('.BPC\\Accounting\\Events\\InvoiceMarkedAsPaid', data => {
        this.eventsSuccess.push(data);
      })
      .listen('.BPC\\Accounting\\Events\\ErrorMarkingInvoiceAsPaid', data => {
        this.eventsError.push(data);
      })
      .listen('.BPC\\Accounting\\Events\\GlobalErrorMarkingInvoiceAsPaid', data => {
        this.$bpcMessage.showErrorMessage({
          text: data.msg,
        });
        this.isProcessing = false;
        this.requestSent = false;
        this.$bpcEcho.leaveMarkInvoicesAsPaidChannel(sessionCode);
      });
  }

  onValidationWarning(event) {
    console.log('onValidationWarning', event);
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // WATCHERS

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
